var map = {
	"./afrihost.png": "65ab",
	"./avast.png": "3cc0",
	"./cisco.png": "d9a9",
	"./kyocera.png": "943e",
	"./microsoft.png": "7c2b",
	"./mustek.png": "fd59"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9f46";